import React from 'react';
import styles from '../../styles';
import { Values, DayKey, HourData, ServiceName, ServiceValue } from '../types';
import { getDayName } from 'helpers/helperFunctions';
import { useAppSelector } from 'index';
import { Button } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';

type DayRowProps = {
    name: DayKey;
    isSunday?: boolean;
    values: Values;
    onClick: (params: ServiceName) => void;
};

export default function ServiceDayRow({
    name,
    isSunday,
    onClick,
    values,
}: DayRowProps) {
    const classes = styles();
    const restaurant = useAppSelector((state) => state.restaurantDetails.restaurantInformation);

    function renderPlus(service: ServiceName, disabled = false) {
        return (
            <Button
                disableRipple
                className={`${classes.serviceHours} ${values[service]?.isActive ? classes.serviceHoursActive : ''}`}
                variant='text'
                disabled={disabled}
                onClick={() => onClick(service)}
                style={{ fontSize: 24 }}
            >
                < AddCircleIcon fontSize='inherit' />
            </Button>
        );
    }

    function getHours(
        service: ServiceName,
        serviceValue: ServiceValue,
        disabled: boolean = false,
    ) {
        const hoursByDay = serviceValue.workingHours[name].length
            ? serviceValue.workingHours[name]
            : [];
        if (hoursByDay.length === 0) return renderPlus(service, disabled);
        /* if (hoursByDay.every((i) => i.from === '00.00' && i.to === '00.00'))
            return renderPlus(service); */
        return (
            <Button
                onClick={() => onClick(service)}
                className={`${classes.serviceHours} ${serviceValue.isActive ? classes.serviceHoursActive : ''}`}
                disabled={disabled}
                variant="text"
                disableRipple
            >
                {hoursByDay.map(({ from, to }: HourData, index) => {
                    return (
                        <span key={`${service}-${name}-${from}-${to}-${index}`}>
                            {from} - {to}
                        </span>
                    );
                })}
            </Button>
        );
    }

    return (
        <div className={classes.serviceDayRowContainer}>
            <div className={classes.serviceRowDayName}>
                <span>{getDayName(name).substring(0, 1).toUpperCase()}</span>
            </div>
            {!restaurant.coolBoxData.isCoolBox && (
                <div style={getColumnStyle({ isSunday })}>
                    <div className={classes.hoursContainer}>
                        {getHours('homeDelivery', values.homeDelivery)}
                    </div>
                </div>
            )}
            <div style={getColumnStyle({ isSunday })}>
                <div className={classes.hoursContainer}>
                    {getHours('takeAway', values.takeAway)}
                </div>
            </div>
            {!restaurant.coolBoxData.isCoolBox && (
                <div style={getColumnStyle({ isSunday })}>
                    <div className={classes.hoursContainer}>
                        {getHours('dineIn', values.dineIn)}
                    </div>
                </div>
            )}
            {!restaurant.coolBoxData.isCoolBox && (
                <div style={getColumnStyle({ isSunday, isLast: true })}>
                    <div className={classes.hoursContainer}>
                        {getHours('takeOut', values.takeOut, true)}
                    </div>
                </div>
            )}
        </div>
    );
}

function getColumnStyle({ isSunday, isLast }: { isSunday?: boolean; isLast?: boolean }) {
    return {
        flexDirection: 'column',
        display: 'flex',
        width: 168,
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #99567E',
        borderBottomLeftRadius: isSunday ? 4 : 0,
        borderBottomRightRadius: isSunday ? 4 : 0,
        borderTopWidth: 0,
        borderBottomWidth: isSunday ? 1 : 0,
        backgroundColor: '#fff',
        marginRight: isLast ? 0 : 8,
    } as React.CSSProperties;
}
